import { DateTime } from 'luxon';
import { SelfServiceInstruction } from '../../api/mutations/selfService/types';
import { HeaderBar, LanguageSelector } from './Header';
import InstructionComponent from './SelfServiceComponents/InstructionComponent';
import { SessionStatus } from './SessionStatus';
import { useSessionManager } from './hooks/useSessionManager';
import { useComponentManager } from './hooks/useComponentManager';
import { Layout } from './Layout';
import SessionLoadingScreen from './SessionLoadingScreen';

type SelfServiceProps = {
  sessionId: string;
  jobsiteId: string;
};

export default function SelfService({ sessionId, jobsiteId }: SelfServiceProps) {
  const { session, isSessionPending, handleSessionExit, handleSessionExtend } = useSessionManager(jobsiteId, sessionId);
  const { instruction, handleNextInstructionRequest } = useComponentManager(jobsiteId, sessionId);

  if (isSessionPending || !session) return <SessionLoadingScreen />;

  return (
    <Layout
      header={<HeaderBar languageSelector={<LanguageSelector />} />}
      sessionStatus={
        <SessionStatus
          session_started_at={session.sessionStartedAt as DateTime}
          session_end_at={session.sessionExpiresAt as DateTime}
          onSessionExit={handleSessionExit}
          onSessionExtend={handleSessionExtend}
        />
      }
      content={
        <InstructionComponent
          instruction={instruction}
          onSubmit={(updatedInst: SelfServiceInstruction) => {
            handleNextInstructionRequest(updatedInst);
          }}
          jobsiteId={jobsiteId}
          sessionId={sessionId}
        />
      }
    />
  );
}
